import Skeleton from '@material-ui/lab/Skeleton';
import { Grid, ListItem, ListItemText } from '@material-ui/core';
import React from 'react';

// CX-5089: skeleton loaders for Group BI map + dialog box + dialog lists
export const BIMapSkeleton = () => {
  return (
    <Skeleton
      animation="wave"
      variant="rect"
      width="100%"
      height="100%"
      style={{ position: 'absolute', top: 0, left: 0 }}
    />
  );
};

interface BIDialogBoxSkeletonProps {
  rows?: number;
}

export const BIDialogBoxSkeleton = ({ rows = 4 }: BIDialogBoxSkeletonProps) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <div className="flex-container" key={index}>
          <div className="item-right">
            <Skeleton animation="wave" variant="text" width="70%" />
          </div>
          <div className="item-left">
            <Skeleton animation="wave" variant="text" width="60%" style={{ marginLeft: 'auto' }} />
          </div>
        </div>
      ))}
    </>
  );
};

interface BIImageGridSkeletonProps {
  tiles?: number;
}

// CX-5089: placeholder for image-grid screens (e.g. Site Gallery)
export const BIImageGridSkeleton = ({ tiles = 3 }: BIImageGridSkeletonProps) => {
  return (
    <>
      {Array.from({ length: tiles }).map((_, index) => (
        <div key={index} style={{ marginBottom: '22px' }}>
          <div style={{ display: 'flex', gap: '8px' }}>
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton
                key={i}
                animation="wave"
                variant="rect"
                width={120}
                height={90}
              />
            ))}
          </div>
          <Skeleton
            animation="wave"
            variant="text"
            width="40%"
            style={{ marginTop: 8 }}
          />
          <Skeleton animation="wave" variant="text" width="70%" />
        </div>
      ))}
    </>
  );
};

interface BIChartSkeletonProps {
  height?: number;
}

// Full-page chart/figure placeholder for the BI submenu screens
export const BIChartSkeleton = ({ height = 250 }: BIChartSkeletonProps) => {
  return (
    <div style={{ width: '100%', padding: '16px 0', textAlign: 'center' }}>
      <Skeleton
        animation="wave"
        variant="text"
        width={180}
        style={{ margin: '0 auto 12px' }}
      />
      <Skeleton animation="wave" variant="rect" width="100%" height={height} />
    </div>
  );
};

interface BIDialogListSkeletonProps {
  count?: number;
}

export const BIDialogListSkeleton = ({ count = 5 }: BIDialogListSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <ListItem key={index}>
          <ListItemText
            primary={
              <>
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={120}
                  style={{ display: 'inline-block' }}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  style={{ display: 'inline-block', flex: 1, margin: '0 8px' }}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={80}
                  style={{ display: 'inline-block' }}
                />
              </>
            }
            secondary={
              <Grid container>
                <Grid item xs={8}>
                  <Skeleton animation="wave" variant="text" width="70%" />
                </Grid>
                <Grid item xs={4} style={{ textAlign: 'right' }}>
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width="60%"
                    style={{ marginLeft: 'auto' }}
                  />
                </Grid>
              </Grid>
            }
          />
        </ListItem>
      ))}
    </>
  );
};
